import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '../ui/badge';

interface PromptVariablesProps {
  variables: string[];
}

const PromptVariables = ({ variables }: PromptVariablesProps) => (
  <Card>
    <CardHeader>
      <CardTitle>Available Variables</CardTitle>
      <CardDescription>These variables can be used in your prompt.</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="flex flex-wrap gap-2">
        {variables.map((variable, index) => (
          <Badge key={index} variant="secondary">
            {`{{${variable}}}`}
          </Badge>
        ))}
      </div>
    </CardContent>
  </Card>
);

export default PromptVariables;
